import { useState, useMemo, useEffect } from 'react';
import './RecentSearch.scss';
import SearchTable from './search-table/SearchTable';
import {
  frameColumnFor_PC_RecentSearch,
  getPriceCompareRecentSearchFormattedData,
} from '../../../utils/common';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import {
  HttpSuccessCodes,
  HttpErrorCodes,
} from 'src/Admin/errorhandling/HttpErrorCodes';
import RecentSearchSkeleton from '../skeleton/RecentSearchSkeleton';
import { useSelector, useDispatch } from 'react-redux';
import { setRecentSearchList } from 'src/redux/admin/priceCompareSlice';
import {
  CustomPagination,
  CustomPaginationItemsDisplay,
} from 'src/Admin/components/common/CustomPagination';
import { Col, Row } from 'react-bootstrap';
import { t } from 'i18next';
import CustomClientError from 'src/Admin/errorhandling/CustomClientError';

const RecentSearch = ({ showingResultItem = 10, searchText = '', member }) => {
  const [pageSize, setPageSize] = useState(showingResultItem);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isError, setError] = useState(false);
  const [isNoData, setNoData] = useState(false);
  const dispatch = useDispatch();
  const { recentSearchList } = useSelector((state) => state?.priceCompareAdmin);

  const displayPaginationMininumCount = 10;

  const [recordsToDisplay, setRecordsToDisplay] = useState(recentSearchList);
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [totleRecords, setTotalRecords] = useState(recentSearchList?.length);

  const sortingDataHandler = (data) => {
    if (data?.length > 0) {
      const sortByTime = data?.slice()?.sort((a, b) => {
        return b?.date - a?.date;
      });
      const sortByPin = sortByTime
        ?.filter((p1) => p1.pin === true)
        .concat(sortByTime?.filter((p1) => p1.pin !== true));
      return sortByPin;
    } else {
      return [];
    }
  };

  const recordsFilterHandler = (masterDataList, pageSize, currentPage) => {
    const filteredData = [];
    sortingDataHandler(masterDataList).forEach((eachItem, index) => {
      if (
        index >= pageSize * currentPage - pageSize &&
        index < pageSize * currentPage
      ) {
        filteredData.push(eachItem);
      }
    });

    setFilteredRecords(filteredData);
    setTotalRecords(masterDataList?.length);
  };

  const pageSizeHandler = (pageSizeInfo) => {
    setCurrentPage(1);
    setPageSize(pageSizeInfo.value);
    recordsFilterHandler(recordsToDisplay, pageSizeInfo.value, 1);
  };

  const columnNames = useMemo(() => {
    return frameColumnFor_PC_RecentSearch();
  }, []);

  const getRecentRequestList = async () => {
    try {
      setLoading(true);
      const URL = APIEndpoints.getPriceCompareRecentSearchListLoginUser();

      const response = await axiosInstance.get(URL);

      if (HttpSuccessCodes.HTTP_SUCCESS_CODE_200 === response?.status) {
        console.log('PC_API Successful', response);
        if (
          response?.data?.Response?.PriceCompareDTOs &&
          response?.data?.Response?.PriceCompareDTOs?.length > 0
        ) {
          const FORMATTED_DATA = sortingDataHandler(
            getPriceCompareRecentSearchFormattedData(
              response?.data?.Response?.PriceCompareDTOs,
            ),
          );
          if (member?.value) {
            const filteredData = FORMATTED_DATA.filter((item) => {
              return item?.request?.serviceForOid === member?.value;
            });
            dispatch(setRecentSearchList(filteredData));
            recordsFilterHandler(filteredData, pageSize, currentPage);
            setFilteredRecords(filteredData);
          } else {
            dispatch(setRecentSearchList(FORMATTED_DATA));
            recordsFilterHandler(FORMATTED_DATA, pageSize, currentPage);
            setFilteredRecords(FORMATTED_DATA);
          }
        } else {
          setError(true);
          setNoData(true);
          dispatch(setRecentSearchList([]));
        }
      } else if (HttpErrorCodes.HTTP_ERROR_CODE_404 === response?.status) {
        setError(true);
        setNoData(true);
      } else {
        setError(true);
      }
      setLoading(false);
      return Promise.resolve(response);
    } catch (error) {
      setError(true);
      setLoading(false);
      if (error.toString().includes('404')) {
        setNoData(true);
      }
    }
  };

  useEffect(() => {
    setError(false);
    setNoData(false);
    getRecentRequestList();
  }, [member]);

  useEffect(() => {
    if (recentSearchList?.length > 0) {
      recordsFilterHandler(
        sortingDataHandler(recentSearchList),
        pageSize,
        currentPage,
      );
    }
  }, [recentSearchList]);

  useEffect(() => {
    if (recentSearchList?.length > 0) {
      const requestTitleFilteredData = recentSearchList?.filter((item) =>
        item?.request?.requestTitle
          ?.toLowerCase()
          ?.includes(searchText.toLowerCase()),
      );

      const serviceForFilteredData = recentSearchList?.filter((item) =>
        item?.request?.serviceFor
          ?.toLowerCase()
          ?.includes(searchText.toLowerCase()),
      );

      const requestIdFilteredData = recentSearchList?.filter((item) =>
        item?.id?.toString()?.toLowerCase()?.includes(searchText.toLowerCase()),
      );

      const providersFilteredData = [];
      for (let i = 0; i < recentSearchList?.length; i++) {
        for (
          let j = 0;
          j < recentSearchList[i]?.request?.providers?.length;
          j++
        ) {
          if (
            recentSearchList[i]?.request?.providers[j]
              ?.toLowerCase()
              ?.includes(searchText?.toLowerCase())
          ) {
            providersFilteredData.push(recentSearchList[i]);
            break;
          }
        }
      }

      const finalFilteredData = new Set(
        sortingDataHandler([
          ...requestTitleFilteredData,
          ...requestIdFilteredData,
          ...providersFilteredData,
          ...serviceForFilteredData,
        ]),
      );
      setPageSize(10);
      setCurrentPage(1);
      setFilteredRecords([...finalFilteredData]);
      setTotalRecords([...finalFilteredData].length);
      setRecordsToDisplay([...finalFilteredData]);
    }
  }, [searchText]);

  return (
    <div
      className={`${
        (filteredRecords?.length > 0 || loading === true || isError) &&
        recentSearchList.length > 0
          ? 'recent-search-main-wrapper'
          : loading === true
          ? 'recent-search-main-wrapper'
          : ' bg-transparent'
      }`}
    >
      {loading === false ? (
        <div className="recent-search-table-container">
          {!(showingResultItem === 5) &&
            totleRecords > displayPaginationMininumCount && (
              <Row className="mt-4 mb-4 align-items-center">
                {totleRecords > displayPaginationMininumCount && (
                  <>
                    <Col sm={6}>
                      <CustomPaginationItemsDisplay
                        pageSize={pageSize}
                        setPageSize={pageSizeHandler}
                        prefixMessage="Records per page"
                        suffixMessage={
                          pageSize < totleRecords
                            ? `Showing ${pageSize * (currentPage - 1) + 1} - ${
                                pageSize * (currentPage - 1) +
                                (filteredRecords?.length <= pageSize
                                  ? filteredRecords?.length
                                  : pageSize)
                              } of ${totleRecords} results`
                            : ''
                        }
                      />
                    </Col>
                    <Col sm={6} className="text-right mt-4 mt-md-0">
                      <div className="claims-pagination d-flex justify-content-end">
                        {totleRecords > displayPaginationMininumCount ? (
                          <CustomPagination
                            pageSize={pageSize}
                            currentPage={currentPage}
                            totalCount={totleRecords}
                            onPageChange={(page) => {
                              setCurrentPage(page);
                              recordsFilterHandler(
                                recordsToDisplay,
                                pageSize,
                                page,
                              );
                            }}
                          />
                        ) : null}
                      </div>
                    </Col>
                  </>
                )}
              </Row>
            )}
          {isError ? (
            <div className="px-0">
              {isNoData ? (
                <div className="document-no-data text-center">
                  {!(showingResultItem === 5) && (
                    <CustomClientError
                      CustomClasses="p-0 m-0"
                      ErrorHeading={t(
                        'member.price_comparison.recent_table.not_found_error_heading',
                      )}
                      ErrorMessage={t(
                        'member.price_comparison.recent_table.not_found_error_message',
                      )}
                    />
                  )}
                </div>
              ) : (
                <div>
                  {!(showingResultItem === 5) && (
                    <CustomClientError
                      ErrorHeading="Something went wrong with request!"
                      ErrorMessage="Server request failed. Please contact support team."
                      CustomClasses="p-0"
                    />
                  )}
                </div>
              )}
            </div>
          ) : (
            <SearchTable
              className="account-table"
              columns={columnNames}
              data={
                filteredRecords?.length > 0
                  ? sortingDataHandler(
                      showingResultItem === 5
                        ? filteredRecords.slice(0, showingResultItem)
                        : filteredRecords,
                    )
                  : []
              }
              keyField={columnNames}
              pageSizeCount={pageSize}
              isSearchText={searchText}
              viewAllLinkVisible={
                showingResultItem === 5 &&
                filteredRecords?.length > showingResultItem
              }
              recordsFilterHandler={recordsFilterHandler}
              setCurrentPagePagination={setCurrentPage}
              setError={setError}
              setNoData={setNoData}
              setRecordsToDisplay={setRecordsToDisplay}
            />
          )}
          {!(showingResultItem === 5) && (
            <Row className="mt-4 mb-4 align-items-center">
              {totleRecords > displayPaginationMininumCount && (
                <>
                  <Col sm={6}>
                    <CustomPaginationItemsDisplay
                      pageSize={pageSize}
                      setPageSize={pageSizeHandler}
                      prefixMessage="Records per page"
                      suffixMessage={
                        pageSize < totleRecords
                          ? `Showing ${pageSize * (currentPage - 1) + 1} - ${
                              pageSize * (currentPage - 1) +
                              (filteredRecords?.length <= pageSize
                                ? filteredRecords?.length
                                : pageSize)
                            } of ${totleRecords} results`
                          : ''
                      }
                    />
                  </Col>
                  <Col sm={6} className="text-right mt-4 mt-md-0">
                    <div className="claims-pagination d-flex justify-content-end">
                      {totleRecords > displayPaginationMininumCount ? (
                        <CustomPagination
                          pageSize={pageSize}
                          currentPage={currentPage}
                          totalCount={totleRecords}
                          onPageChange={(page) => {
                            setCurrentPage(page);
                            recordsFilterHandler(
                              recordsToDisplay,
                              pageSize,
                              page,
                            );
                          }}
                        />
                      ) : null}
                    </div>
                  </Col>
                </>
              )}
            </Row>
          )}
        </div>
      ) : (
        <RecentSearchSkeleton />
      )}
    </div>
  );
};

export default RecentSearch;
